import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=4c1a8f6c&scoped=true&"
import script from "./AccordionItem.vue?vue&type=script&lang=js&"
export * from "./AccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./AccordionItem.vue?vue&type=style&index=0&id=4c1a8f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a8f6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1a8f6c')) {
      api.createRecord('4c1a8f6c', component.options)
    } else {
      api.reload('4c1a8f6c', component.options)
    }
    module.hot.accept("./AccordionItem.vue?vue&type=template&id=4c1a8f6c&scoped=true&", function () {
      api.rerender('4c1a8f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/Accordion/AccordionItem.vue"
export default component.exports